import React from "react";
import { Box, Typography } from "@mui/material";

const SectionHeader = ({
    title,
    description,
    titleClassName = "",
    descriptionClassName = "",
    titleSx = {},
    descriptionSx = {},
    hideDivider = false,
}) => {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: "center",
                justifyContent: "space-between",
                gap: { xs: 3, md: 5 },
                mb: { xs: 8, md: 5 },
            }}
        >
            <Typography
                variant="h2"
                className={titleClassName}
                sx={{
                    flexShrink: 0,
                    maxWidth: { xs: "100%", md: "520px" },
                    textAlign: { xs: "center", md: "left" },
                    ...titleSx,
                }}
            >
                {title}
            </Typography>

            {!hideDivider && (
                <Box
                    sx={{
                        display: "none",
                        "@media (min-width:1024px)": {
                            display: "block",
                        },
                        width: "1px",
                        height: "60px",
                        backgroundColor: "rgba(255,255,255,0.15)",
                        alignSelf: "center",
                    }}
                />
            )}

            <Typography
                className={descriptionClassName}
                sx={{
                    flex: 1,
                    fontSize: { xs: "0.95rem", md: "1.05rem" },
                    lineHeight: 1.7,
                    maxWidth: { xs: "100%", md: "520px" },
                    textAlign: { xs: "center", md: "left" },
                    ...descriptionSx,
                }}
            >
                {description}
            </Typography>
        </Box>
    );
};

export default SectionHeader;